<template>
  <p class="text-center text-sm text-gray-600">
    Ao selecionar, você concorda com os 
    <a href="https://misteriosdodestino.com/termos-de-uso" class="text-primary hover:text-primary-dark font-medium">
      Termos de Uso
    </a> e
    <a href="https://misteriosdodestino.com/politica-de-privacidade" class="text-primary hover:text-primary-dark font-medium">
      Política de Privacidade
    </a>
  </p>
</template>